/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';
import { FSF_BRAND } from '../fsfPages.generated';
import VideoFrame from './VideoFrame';

export default function FsfHero({ page, isHome }) {
  const hasVideo = Boolean(page.heroVideo);
  const heroStyle = !hasVideo && page.featuredImage
    ? { '--fsf-hero-image': `url("${page.featuredImage}")` }
    : undefined;

  return (
    <section className={`fsf-hero ${isHome ? 'fsf-hero--home' : 'fsf-hero--page'} ${hasVideo ? 'fsf-hero--video' : ''}`} style={heroStyle}>
      {hasVideo ? <VideoFrame url={page.heroVideo} title={`${page.title} hero video`} background /> : null}
      <div className="fsf-hero__shade" aria-hidden="true" />
      <div className="fsf-hero__content">
        {isHome ? (
          <img className="fsf-hero__mark" src={FSF_BRAND.logo} alt="" loading="eager" />
        ) : null}
        <p className="fsf-eyebrow">{FSF_BRAND.tagline}</p>
        <h1>{page.title}</h1>
        {page.description ? <p className="fsf-hero__summary">{page.description}</p> : null}
        {isHome ? (
          <div className="fsf-hero__actions">
            <a className="fsf-button" href="/logistics/">Logistics Division</a>
            <a className="fsf-button fsf-button--secondary" href="/moving/">Moving Division</a>
            <a className="fsf-button fsf-button--ghost" href={FSF_BRAND.quoteUrl}>Get a Quotation</a>
          </div>
        ) : null}
      </div>
    </section>
  );
}
